/**
 * @generated SignedSource<<d3e797e679153dc466590624080f9f8a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UserRole = "CLIENT" | "COACH" | "%future added value";
export type useSwitchUserSignInAsMutation$variables = {
  userId?: string | null | undefined;
};
export type useSwitchUserSignInAsMutation$data = {
  readonly signInAs: {
    readonly me: {
      readonly admin: boolean;
      readonly id: string;
      readonly role: UserRole;
    } | null | undefined;
  } | null | undefined;
};
export type useSwitchUserSignInAsMutation = {
  response: useSwitchUserSignInAsMutation$data;
  variables: useSwitchUserSignInAsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "userId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "userId",
        "variableName": "userId"
      }
    ],
    "concreteType": "SignIsAsPayload",
    "kind": "LinkedField",
    "name": "signInAs",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "role",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "admin",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useSwitchUserSignInAsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useSwitchUserSignInAsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c7a66dd2bc405dcc871d6887d8a90ad0",
    "id": null,
    "metadata": {},
    "name": "useSwitchUserSignInAsMutation",
    "operationKind": "mutation",
    "text": "mutation useSwitchUserSignInAsMutation(\n  $userId: String\n) {\n  signInAs(userId: $userId) {\n    me {\n      id\n      role\n      admin\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "2221b66cfc2796b996b99cbb5efb5253";

export default node;
